export interface Container {
    name: string;
    containerName: string;
    image: string;
    version: string;
  }

  export interface KindGroup {
    kind: string;
    count: number;
    spec: {
      containers: Container[];
    };
    name?: { name: string }[];
  }

  export interface NameGroup {
    name: string;
    kinds: KindGroup[];
  }

  export interface ResourceInput {
    name: string;
    namespace: string;
    kind: string;
    spec: {
      containers?: {
        name: string;
        image: string;
      }[];
    };
  }

  export class KubernetesResource {
    static transformResourcesAllNamespaces(input: ResourceInput[]): NameGroup[] {
      const allowedKinds = ['Deployment', 'Statefulset', 'Daemonset', 'Service', 'ConfigMap', 'Secret'];
      const outputMap: Map<string, Map<string, KindGroup>> = new Map();

      for (const resource of input) {
        const nsName = resource.namespace;
        const kind = resource.kind;

        if (!allowedKinds.includes(kind)) continue;

        // if (!outputMap.has(nsName)) {
        //   outputMap.set(nsName, new Map());
        // }

        if (!outputMap.has(nsName)) {
          const kindMap = new Map<string, KindGroup>();
          for (const allowedKind of allowedKinds) {
            kindMap.set(allowedKind, {
              kind: allowedKind,
              count: 0, 
              spec: {
                containers: []
              }
            });
          }
          outputMap.set(nsName, kindMap);
        }

        const kindMap = outputMap.get(nsName)!;

        if (!kindMap.has(kind)) {
          kindMap.set(kind, {
            kind,
            count: 0, 
            spec: {
              containers: []
            }
          });
        }

        const kindGroup = kindMap.get(kind)!;

        kindGroup.count += 1;

        if (resource.spec?.containers?.length) {
          for (const container of resource.spec.containers) {
            kindGroup.spec.containers.push({
              name: resource.name,
              containerName: container.name,
              image: container.image,
              version: splitImageVersion(container.image)
            });
          }
        } else {
          if (!kindGroup.name) {
            kindGroup.name = [];
          }
          kindGroup.name.push({name: resource.name});
        }
      }

      const output: NameGroup[] = [];
      for (const [nsName, kindMap] of outputMap.entries()) {
        output.push({
          name: nsName,
          kinds: Array.from(kindMap.values())
        });
      }
      return output;
    }
  }

// splits version from image
  function splitImageVersion(image: string) {
    const lastColonIndex = image.lastIndexOf(':');
    const lastSlashIndex = image.lastIndexOf('/');
    if (lastColonIndex > lastSlashIndex) {
      return image.substring(lastColonIndex + 1)
       }
    return '';
  }

